export class Operacion {
  idOperacion:string = "";
  Alta_Usuario:string = '';
  ARUC :string = '';
  aRazonSocial:string = '';
  PRUC:string = '';
  pRazonSocial:string = '';
  Direccion_Fiscal:string = '';
  Departamento:string = '';
  Provincia:string = '';
  Distrito: string = '';
  PRV_Representante_Legal_1: string = '';
  PRV_Representante_Legal_2:string = '';
  Banco :number = 0;
  Correo: string = '';
  IF_Representante_Legal_1: string = '';
  IF_Representante_Legal_2:string = '';
  Moneda:number = 0;
  Moneda_Dsc:string = '';
  Tasa_Mensual = 0;
  Adelanto_porcentaje:number;
  Fecha_Desembolso:Date = new Date();
  Fecha_Operacion:Date = new Date();
  Adelanto_Importe= 0;
  Remanente_Importe= 0;
  Desembolso_Importe =0 ;
  Interes_Importe = 0;
  Comision_Importe ='0.00';
  IGV_Importe = 0;
  Factoring_SUNAT_Importe =0;
  Adelanto_Ejecutado_importe=0;
  Adelanto_Pendiente_importe=0;
  Mon:string = '';
  MontoADesembolsar =0;
  VNPP=0;
  }
  